export const USER_COMPLETED_ONBOARDING = "userCompletedOnboarding";
export const USER_HAS_ONBOARDING_TASKS = "userHasOnboardingTasks";
export const USER_CLOSED_ONBOARDING = "userClosedOnboarding";
export const USER_CLOSED_ONBOARDING_HUB = "userClosedOnboardingHub";
